// extracted by mini-css-extract-plugin
export default {"Wrapper":"AuthStrategyRadioButton_Wrapper__nIwTy","Radio":"AuthStrategyRadioButton_Radio__BYS3F"};